import { IClassRoomData, ICreatedClass } from '@/store/types';
import { PayloadAction } from '@reduxjs/toolkit';
import { createSliceSteamup } from '../common';

interface IClassDocumentsState{
  classDocuments: string;
  searchString: string;
  classRoomList: IClassRoomData[];
}
const classDocumentSlice = createSliceSteamup(
  'classDocuments',
  {
    classDocuments: '',
    searchString: '',
    classRoomList: [],
  } as IClassDocumentsState,
  {
    setListInit(state, { payload }: PayloadAction<(typeof state.classDocuments)>) {
      state.classDocuments = payload;
    },
    setClassRoomListInit(state, { payload }: PayloadAction<(typeof state.classRoomList)>) {
      state.classRoomList = payload;
    },
  },
);

export default classDocumentSlice;
